export default "/videos/5d2785511cf5aa0873e5a41189d6edcf.mp4";